import type { CreateUpdateOrderDTO, OrderDTO } from 'ecosystem'
import { createError, fetchPropsFactory, storefrontApiCall } from '../../utils/fetching'
import { ORDERS_ENDPOINT } from './constants'

export async function updateStorefrontOrder(order: CreateUpdateOrderDTO) {
  const props = fetchPropsFactory({
    props: {
      method: 'PUT',
      body: JSON.stringify(order)
    }
  })

  const { data, error } = await storefrontApiCall<OrderDTO>(ORDERS_ENDPOINT, props)

  if (error || !order) {
    throw createError(error || 'Update storefront order error')
  }

  return data
}
